import React, { createContext, useContext, useState, useMemo } from "react";

interface ThemeModeContextType {
    isDarkMode: boolean;
    toggleDarkMode: () => void;
}

const ThemeModeContext = createContext<ThemeModeContextType | undefined>(undefined);

export const ThemeModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    const value = useMemo(() => ({
        isDarkMode,
        toggleDarkMode: () => setIsDarkMode((prev) => !prev),
    }), [isDarkMode]);

    return (
        <ThemeModeContext.Provider value={value}>
            {children}
        </ThemeModeContext.Provider>
    );
};

export const useThemeMode = () => {
    const context = useContext(ThemeModeContext);
    if (!context) throw new Error("useThemeMode must be used within ThemeModeProvider");
    return context;
}
